import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';


@Pipe({
  name: 'translateArray',
  standalone: true
})
export class TranslateArrayPipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  public transform(value: string[] | null | undefined, translatePrefix: string): string | null | undefined {
    if (!Array.isArray(value)) return value;
    const translated = value.map(val => this.translate.instant(translatePrefix + val));
    return translated.join(', ');
  }
}
